<template>
	<article class="notification card" :class="`notification--${ data.emotion }`">
		<i class="notification__icon" :class="`notification__icon--${ data.emotion }`">
			<Icon name="check" v-if="data.emotion === 'success'" />
			<Icon name="close" v-if="data.emotion === 'failed'" />
		</i>
		<div class="notification__head">
			<p class="notification__title">{{ title }}:</p>
			<p class="notification__date">{{ date }}</p>
		</div>
		<p class="notification__content">{{ content }}</p>
	</article>
</template>
<script lang="ts" setup>
import {NotificationEntity} from "@/entities/NotificationEntity";
import "./Notification.scss";
import {computed} from "vue";
import moment from "moment";
import Icon from "@/components/Icon/Icon.vue";

interface Props{
	notification : NotificationEntity
}

let props = defineProps<Props>();

let data = computed<any>(() => {
	return props.notification.data;
});

let title = computed<string>(() => {
	return data.value.emotion === 'success' ? 'Successful' : 'Unsuccessful';
});

let date = computed<string>(() => {
	return moment(props.notification.created_at).format('DD.MM.YYYY HH:mm');
});

let content = computed<string>(() => {

	switch(data.value.type){

		case 'WithdrawalSuccess':
			return `Withdrawal of ${data.value.amount} USDT completed.`

		case 'WithdrawalFailed':
			return `Check your wallet address and try again.`;

		case 'DepositSuccess':
			return `Deposit of ${data.value.amount} USDT completed.`

		default:
			return '';

	}

});

</script>